import type { Business, BusinessSettlementAccount } from '@/types/business';
import type { User } from '@/types/user';

export const getBusinessSettlementAccount = (
  business?: Business | null,
  user?: User | null
): BusinessSettlementAccount | undefined => {
  const account =
    business?.settlementAccount ?? user?.business?.settlementAccount;
  if (!account?.accountNumber) return undefined;
  return account;
};

export const hasBusinessSettlementAccount = (
  business?: Business | null,
  user?: User | null
): boolean => !!getBusinessSettlementAccount(business, user);

export const formatSettlementAccountLabel = (
  account?: BusinessSettlementAccount | null
): string | undefined => {
  if (!account?.accountNumber) return undefined;

  const lastFour = account.accountNumber.slice(-4);
  const bankDisplay =
    account.bankName?.replace(/\s*\([^)]*\)\s*$/, '').trim() || 'Bank';

  return `${bankDisplay} ****${lastFour}`;
};
